import styled from 'styled-components';

export const Heading4 = styled.h4`
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
`;
